import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Contact', href: '/contact' },
];

const dotColors = ['bg-[#38BDF8]', 'bg-[#FBBF24]', 'bg-[#F472B6]', 'bg-[#A3E635]', 'bg-[#FB923C]'];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-[#0A0F2E]/45 backdrop-blur-md py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-10 h-10 flex items-center justify-center relative">
            <div className="absolute inset-0 bg-[#38BDF8] rounded-xl rotate-6 group-hover:rotate-12 transition-transform" />
            <div className="absolute inset-0 bg-[#FBBF24] rounded-xl -rotate-3 group-hover:-rotate-6 transition-transform" />
            <span className="relative text-white font-black text-lg z-10">G</span>
          </div>
          <span className={`font-black text-lg tracking-tight transition-colors ${scrolled ? 'text-gray-800' : 'text-white'}`}>
            Grandeur
            <span className={`${scrolled ? 'text-[#38BDF8]' : 'text-[#FBBF24]'}`}> Architect</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-6">
          {navItems.map((item, i) => (
            <li key={item.href}>
              <Link
                to={item.href}
                className={`text-sm font-bold tracking-wide transition-colors relative cursor-pointer group ${
                  scrolled ? 'text-gray-700' : 'text-white/90'
                } ${location.pathname === item.href ? 'text-[#38BDF8]' : ''}`}
              >
                {item.label}
                <span
                  className={`absolute -bottom-1 left-0 h-0.5 rounded-full transition-all duration-300 ${dotColors[i % dotColors.length].replace('bg-', 'bg-')} ${
                    location.pathname === item.href ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                  style={{
                    background: ['#38BDF8', '#FBBF24', '#F472B6', '#A3E635', '#FB923C'][i % 5],
                  }}
                />
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <Link
          to="/contact"
          className="hidden md:flex items-center gap-2 bg-[#FBBF24] text-gray-900 font-black text-sm px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#F59E0B] transition-all hover:scale-105"
        >
          お問い合わせ
          <i className="ri-send-plane-fill text-base" />
        </Link>

        {/* Hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex flex-col items-center justify-center gap-1.5 cursor-pointer rounded-full transition-all ${scrolled ? 'text-gray-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <span className={`block w-5 h-0.5 bg-current rounded transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-5 h-0.5 bg-current rounded transition-all ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-5 h-0.5 bg-current rounded transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white px-6 py-5 flex flex-col gap-3">
          {navItems.map((item, i) => (
            <Link
              key={item.href}
              to={item.href}
              className="font-bold text-sm py-2.5 px-4 rounded-xl transition-all cursor-pointer"
              style={{
                background: location.pathname === item.href
                  ? ['#38BDF8', '#FBBF24', '#F472B6', '#A3E635', '#FB923C'][i % 5] + '20'
                  : '#F8F8F8',
                color: ['#0EA5E9', '#D97706', '#EC4899', '#65A30D', '#EA580C'][i % 5],
              }}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="bg-[#FBBF24] text-gray-900 font-black text-sm px-5 py-3 rounded-full text-center mt-2 cursor-pointer whitespace-nowrap"
            onClick={() => setMenuOpen(false)}
          >
            お問い合わせ
          </Link>
        </div>
      )}
    </nav>
  );
}
